<div class="modal-header">
    <h4 class="modal-title">Add Parts from Assembly BOM</h4>
</div>

<div class="modal-body">

    <!-- ── Section 1: Select Parent Assemblies ──────────────────────────── -->
    <div class="section-header d-flex align-items-center mb-2">
        <strong class="me-3">1. Select Parent Parts &amp; Quantities</strong>
        <button class="btn btn-sm btn-secondary" (click)="addAssemblyRow()">
            <i class="fa fa-plus me-1"></i> Add Part
        </button>
    </div>

    <table class="table table-sm table-bordered mb-3" *ngIf="selectedAssemblies.length > 0">
        <thead class="thead-light">
            <tr>
                <th style="width: 40px;"></th>
                <th>Part Number</th>
                <th>Description</th>
                <th style="width: 110px;">Quantity</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of selectedAssemblies; let i = index">
                <td class="text-center">
                    <a title="Remove" (click)="removeAssemblyRow(i)" style="cursor:pointer;">
                        <i class="fa fa-times" style="color: maroon;"></i>
                    </a>
                </td>
                <td>{{ row.part.partNumber }}</td>
                <td>{{ row.part.description }}</td>
                <td>
                    <dx-number-box [(value)]="row.quantity" [min]="1" [step]="1" width="90"></dx-number-box>
                </td>
            </tr>
        </tbody>
    </table>

    <p class="text-muted" *ngIf="selectedAssemblies.length === 0">
        No parent parts selected. Click <strong>Add Part</strong> to begin.
    </p>

    <button
        class="btn btn-sm btn-primary mb-4"
        [disabled]="selectedAssemblies.length === 0 || calculating"
        (click)="calculateLines()"
    >
        <i class="fa fa-calculator me-1"></i> Calculate Child Parts
    </button>

    <!-- ── Section 2: Preview Resolved Lines ────────────────────────────── -->
    <ng-container *ngIf="calculated">
        <div class="section-header mb-2">
            <strong>2. Preview — Parts to be Added to PO</strong>
            <span class="ms-2 text-muted">({{ resolvedLines.length }} part(s))</span>
        </div>

        <table class="table table-sm table-bordered mb-3" *ngIf="resolvedLines.length > 0">
            <thead class="thead-light">
                <tr>
                    <th>Part Number</th>
                    <th>Description</th>
                    <th style="width: 90px;">Qty</th>
                    <!-- <th>Assembly?</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let line of resolvedLines">
                    <td>{{ line.part.partNumber }}</td>
                    <td>{{ line.part.description }}</td>
                    <td>{{ line.quantity }}</td>
                    <!-- <td>{{ line.part.isAssembly ? 'Yes' : '' }}</td> -->
                </tr>
            </tbody>
        </table>

        <p class="text-warning" *ngIf="resolvedLines.length === 0">
            No child parts found for the selected parent(s). Ensure they have children configured.
        </p>

        <div class="alert alert-info mb-0" *ngIf="notesSummary">
            <strong>Note to be appended:</strong> {{ notesSummary }}
        </div>
    </ng-container>

</div>

<div class="modal-footer">
    <button
        class="btn btn-success"
        [disabled]="!calculated || resolvedLines.length === 0"
        (click)="confirm()"
    >
        Add to Purchase Order
    </button>
    <button class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
